import LawSchoolInfoContent from './LawSchoolInfoContent';

export default LawSchoolInfoContent;
